import aceBuilds from "ace-builds";
//#region src/editorOptions.ts
const editorOptions = [
	"minLines",
	"maxLines",
	"readOnly",
	"highlightActiveLine",
	"tabSize",
	"enableBasicAutocompletion",
	"enableLiveAutocompletion",
	"enableSnippets"
];
const editorEvents = [
	"onChange",
	"onFocus",
	"onInput",
	"onBlur",
	"onCopy",
	"onPaste",
	"onSelectionChange",
	"onCursorChange",
	"onScroll",
	"handleOptions",
	"updateRef"
];
const getAceInstance = () => {
	if (typeof window !== "undefined" && window.ace) {
		const ace = window.ace;
		ace.acequire = ace.require || ace.acequire;
		return ace;
	}
	return aceBuilds;
};
const debounce = (fn, delay) => {
	let timer = null;
	return function() {
		const context = this;
		const args = arguments;
		clearTimeout(timer);
		timer = setTimeout(() => {
			fn.apply(context, args);
		}, delay);
	};
};
//#endregion
export { debounce, editorEvents, editorOptions, getAceInstance };

//# sourceMappingURL=editorOptions.mjs.map